// extracted by mini-css-extract-plugin
export default {"form":"dinamicform_form__TUHHB","required":"dinamicform_required__o+SeU"};